import { getFsizeValue, newBlurFilterRun } from './MTIKBlurWebglFilter';

interface ISizeInfo {
    leftEdge: boolean;
    rightEdge: boolean;
    topEdge: boolean;
    bottomEdge: boolean;
    x: number;
    y: number;
    width: number;
    height: number;
}

const sleep = (time: number) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(0);
        }, time);
    });
};

// 分块
export const splitCanvas = (sourceCanvas: HTMLCanvasElement | HTMLImageElement, sizeInfo: ISizeInfo) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = sizeInfo.width;
    canvas.height = sizeInfo.height;
    if (ctx) {
        ctx.drawImage(
            sourceCanvas,
            sizeInfo.x,
            sizeInfo.y,
            sizeInfo.width,
            sizeInfo.height,
            0,
            0,
            sizeInfo.width,
            sizeInfo.height,
        );
    }
    return canvas;
};

// 拼图
export const mergeCanvas = (
    targetWidth: number,
    targetHeight: number,
    sourceList: Array<ISizeInfo & { resCanvas: HTMLCanvasElement | null }>,
    blurSize: number,
) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    if (ctx) {
        sourceList.forEach((item, index) => {
            if (item.resCanvas) {
                ctx.drawImage(
                    item.resCanvas,
                    !item.leftEdge ? blurSize : 0, // sx
                    !item.topEdge ? blurSize : 0, // sy
                    !item.leftEdge && !item.rightEdge ? item.width - 2 * blurSize : item.width - blurSize, // sw
                    !item.topEdge && !item.bottomEdge ? item.height - 2 * blurSize : item.height - blurSize, // sh
                    !item.leftEdge ? item.x + blurSize : 0, // dx
                    !item.topEdge ? item.y + blurSize : 0, // dy
                    !item.leftEdge && !item.rightEdge ? item.width - 2 * blurSize : item.width - blurSize, // sw
                    !item.topEdge && !item.bottomEdge ? item.height - 2 * blurSize : item.height - blurSize, // sh
                );
            }
        });
    }
    return canvas;
};

export async function chunkWebglComposite(
    imageCanvas: HTMLCanvasElement | HTMLImageElement,
    maskCanvas: HTMLCanvasElement | HTMLImageElement,
) {
    const { width, height } = imageCanvas;
    const { width: maskWdith } = maskCanvas;
    const ratio = maskWdith / width;
    const blurSize = Math.round(getFsizeValue(imageCanvas.width, imageCanvas.height));

    // 等分成 2x2 的网格
    const rows = 2;
    const cols = 2;

    // 保证每块宽高为整数，余数分配给行、列最后一块
    const widthRemainder = width % cols;
    const heightRemainder = height % rows;

    // 计算每块的宽度和高度
    const blockWidth = Math.round((width - widthRemainder) / cols);
    const blockHeight = Math.round((height - heightRemainder) / rows);

    // 存储每块的坐标
    const sizeInfoList: Array<ISizeInfo> = [];
    // 遍历每个块，计算其坐标
    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            const leftEdge = col === 0; // 靠近左边缘
            const rightEdge = col === cols - 1; // 靠近左边缘
            const topEdge = row === 0; // 靠近上边缘
            const bottomEdge = row === rows - 1; // 靠近下边缘

            const curBlockWidth = rightEdge ? blockWidth + widthRemainder : blockWidth;
            const curBlockHeight = bottomEdge ? blockHeight + heightRemainder : blockHeight;
            const x = leftEdge ? col * curBlockWidth : col * curBlockWidth - blurSize;
            const y = topEdge ? row * curBlockHeight : row * curBlockHeight - blurSize;
            sizeInfoList.push({
                leftEdge,
                rightEdge,
                topEdge,
                bottomEdge,
                x: rightEdge ? x - widthRemainder : x,
                y: bottomEdge ? y - heightRemainder : y,
                width: curBlockWidth + (!leftEdge && !rightEdge ? 2 * blurSize : blurSize),
                height: curBlockHeight + (!topEdge && !bottomEdge ? 2 * blurSize : blurSize),
            });
        }
    }

    const chunkList = [];

    // 分块处理-串行
    for (let i = 0; i < sizeInfoList.length; i++) {
        const sizeInfo = sizeInfoList[i];
        const sourceCanvasChunk = splitCanvas(imageCanvas, sizeInfo);
        const maskCanvasChunk = splitCanvas(maskCanvas, {
            leftEdge: sizeInfo.leftEdge,
            rightEdge: sizeInfo.rightEdge,
            topEdge: sizeInfo.topEdge,
            bottomEdge: sizeInfo.bottomEdge,
            x: sizeInfo.x * ratio,
            y: sizeInfo.y * ratio,
            width: sizeInfo.width * ratio,
            height: sizeInfo.height * ratio,
        });
        const resultCanvasChunk = await newBlurFilterRun(
            sizeInfo.width,
            sizeInfo.height,
            sourceCanvasChunk,
            maskCanvasChunk,
            blurSize,
        );
        // 添加延时 渲染UI
        await sleep(100);

        chunkList.push({
            ...sizeInfo,
            resCanvas: resultCanvasChunk,
        });
    }

    return mergeCanvas(width, height, chunkList, blurSize);
}
